import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectDbasQueryItems } from '../../../../../redux/dbas/selector';
import { dbas } from '../../../../../redux/dbas/action';
import { selectDomainsListItems } from '../../../../../redux/domains/selector';
import { selectnetworksListItems } from '../../../../../redux/networks/selector';
import { networks } from '../../../../../redux/networks/action';
import { domains } from '../../../../../redux/domains/action';
import { DBAComponent } from '../component/dba.component';
import * as R from "ramda"
import { selectapplicationsListItems } from '../../../../../redux/applications/selector';
import { applications } from '../../../../../redux/applications/action';
import { selectGatewaysListItems } from '../../../../../redux/gateways/selector';
import { gateways } from '../../../../../redux/gateways/action';

const DBA= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectDbasQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
   const domainItems = useSelector(selectDomainsListItems)
   const NetworkItems = useSelector(selectnetworksListItems)
  const applicationItems = useSelector(selectapplicationsListItems)
     const gatewayItems = useSelector(selectGatewaysListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedDba,
    setSelectedDba
  ] = useState<any>([])
 
  const fetchdbasById= ()=>{
    dispatch(dbas.query({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-dbas/query`,entity:'dbass',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDba({ ...selectedDba, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedDba({ ...selectedDba, [fields[0]]: value });
  }
  useEffect(
    () => {
     dispatch(networks.list({
             url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`,
             entity: 'networks',
             jsonData: {}
         })).then(()=>{
           dispatch(domains.list({
             url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains/list`,
             entity: 'domains',
             jsonData: {}
            })).then(()=>{  
              dispatch(applications.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/applications/list`,entity:'applications',jsonData:{
                      }}))}).then(()=>{  
                        dispatch(gateways.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-gateways/list`,entity:'domains',jsonData:{
                                }}))})
      if (parmas?.id > 0) {
        fetchdbasById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    })},
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDba(queryItems?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const dbaData = {
      "Id": selectedDba?.Id || 0,
      "Name": selectedDba?.Name,
      "Description": selectedDba?.Description,
      "Types": selectedDba?.Types || [],
      "Url": selectedDba?.Url,
      "DomainMappings": {
          "Domains": selectedDba?.DomainMappings?.Domains|| []
      },
      "GatewayMappings": {
          "Gateways": selectedDba?.GatewayMappings?.Gateways|| []
      },
      "ApplicationMappings": {
          "Applications": selectedDba?.ApplicationMappings?.Applications||[]
      },
      "NetworkMappings": {
          "Networks": selectedDba?.NetworkMappings?.Networks||[]
      }
  };
  

    if (parmas?.id > 0) {
      await dispatch(dbas.resetAction({ actionType: 'update' }))
     await dispatch(dbas.update({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-dbas`,entity:'dbass',jsonData:{
          
    Records: [
      
        
       
        dbaData
        
    
     
    
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(dbas.resetAction({ actionType: 'create' }))
      await dispatch(dbas.create({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-dbas`,entity:'dbass',jsonData:{
          
      Records: [
        dbaData
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/platform-management/dbas')
} 

    return (
    <>
       {isLoading ? <PageLoader /> : 
          <DBAComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedDba={selectedDba}
            domainDetails={domainItems?.result?.items}
            networks={NetworkItems?.result?.items}
           back={back}
           handleFormSubmit={handleFormSubmit}
           handleFormChange={handleFormChange}
           applications={applicationItems?.result?.items}
           gateways={gatewayItems?.result?.items}
          /> 
    } 
          </>
    )
    
    }
   
    export default DBA;
